import HubspotForm from "react-hubspot-form";
import LoadingSpinner from "../LoadingSpinner";
import { LoadingContainer } from "./styles";

const HubspotContactForm = () => {
  return (
    <HubspotForm
      portalId={process.env.REACT_APP_HUBSPOT_PORTAL_ID}
      formId={process.env.REACT_APP_HUBSPOT_FORM_ID}
      loading={
        <LoadingContainer>
          <LoadingSpinner />
        </LoadingContainer>
      }
    />
  );
};

export default HubspotContactForm;
